// eslint-disable-next-line @typescript-eslint/ban-ts-comment -- DIRECT-239681
//@ts-ignore - В типах реакта нет этих функций, но на самом деле они экспортируются
import { jsx as jsxOriginal, jsxs as jsxsOriginal, Fragment } from 'react/jsx-runtime';
import { RateLimiter } from '../helpers/RateLimiter/RateLimiter';
import { rateLimiterOptions } from './constants';

const limiter = new RateLimiter(rateLimiterOptions);

export { Fragment };
export const jsx = limiter.wrap(jsxOriginal);
export const jsxs = limiter.wrap(jsxsOriginal);
